import { useSetRecoilState } from "recoil";
import { crudUsersAdminAtom, usersAdminAtom } from "../atoms/users-admin.atom";
import UsersAdminApi from "../api/users-admin.api";

const useUsersAdminAction = () => {
  const setUsersAdminCrud = useSetRecoilState(crudUsersAdminAtom);
  const setUsersAdmin = useSetRecoilState(usersAdminAtom)

  const createUsersAdmin = async (data, cb) => {
    setUsersAdminCrud((prevValues) => ({ ...prevValues, loading: true }));
    try {
      const response = await UsersAdminApi.createUsersAdmin(data);

      setUsersAdminCrud((prevValues) => ({
        ...prevValues,
        loading: false,
        status: response.status,
      }));

      if (cb) {
        cb(response);
      }
    } catch (error) {
      console.error('[createUsersAdmin] Error:', error);
      
      setUsersAdminCrud((prevValues) => ({
        ...prevValues,
        loading: false,
        message: error.response?.data?.message || error.message,
        status: error.response?.status || 500,
        error: JSON.stringify(error),
      }));
      
      if (cb) {
        cb(error);
      }
    }
  };

  const usersAdminsList = async (groupName, cb) => {
    setUsersAdmin((prevValues) => ({ ...prevValues, loading: true }));
    try {
      const response = await UsersAdminApi.listUsersByGroup(groupName);
      
      if (cb) {
        cb(response.data);
      }
      
      setUsersAdmin((prevValues) => ({ 
        ...prevValues, 
        loading: false, 
        payload: response.data || [] 
      }));
    } catch (error) {
      setUsersAdmin((prevValues) => ({ ...prevValues, loading: false, error }));
    }
  }

  const deleteUsersAdmin = async (username, cb) => {
    setUsersAdminCrud((prevValues) => ({ ...prevValues, loading: true }));
    try {
      const response = await UsersAdminApi.deleteUsersAdmin(username);
      
      if (cb) {
        cb(response);
      }
      
      setUsersAdminCrud((prevValues) => ({ 
        ...prevValues, 
        loading: false, 
        status: response.status 
      }));
    } catch (error) {
      console.error('[deleteUsersAdmin] Error:', error);
      if (cb) {
        cb(error);
      }
      setUsersAdminCrud((prevValues) => ({
        ...prevValues,
        loading: false,
        message: 'Error eliminando usuario',
        status: 500,
        error,
      }));
    }
  }

  const updateUsersAdminsAttributes = async (username, userAttributes, cb) => {
    setUsersAdminCrud((prevValues) => ({ ...prevValues, loading: true }));
    try {

      const updateData = {};
      userAttributes.forEach(({ Name, Value }) => {
        switch (Name) {
          case 'name':
            // Split name into first and last if needed
            updateData.name = Value;
            break;
          case 'family_name':
            // Combine with name if we have both
            if (updateData.name) {
              updateData.name = `${updateData.name} ${Value}`;
            }
            break;
          case 'phone_number':
            updateData.usersPhone = Value;
            break;
          case 'custom:admin':
            updateData.isAdmin = Value === 'true';
            break;
          case 'custom:userBasic':
            updateData.isBasic = Value === 'true';
            break;
          // Skip email as it shouldn't be updated
          case 'email':
            break;
          default:
            break;
        }
      });

      const response = await UsersAdminApi.updateUsersAdmin(username, updateData);
      
      setUsersAdminCrud((prevValues) => ({ 
        ...prevValues, 
        loading: false, 
        status: response.status 
      }));
      
      if (cb) {
        cb(response);
      }
    } catch (error) {
      setUsersAdminCrud((prevValues) => ({
        ...prevValues,
        loading: false,
        message: 'Error actualizando el usuario admin',
        status: 500,
        error,
      }));
    }
  }

  const resetUsersAdminCrud = () => setUsersAdminCrud({ status: 500, message: '', loading: false });

  return{
    createUsersAdmin,
    usersAdminsList,
    deleteUsersAdmin,
    updateUsersAdminsAttributes,
    resetUsersAdminCrud
  }
};

/* TODO what is this function for?
const allUsersAdminSelector = selector({
  key: 'usersAdmins',
  get: async({clientName}) => {
    const cognitoIdentityServiceProvider = new CognitoIdentityServiceProvider();
    const params = {
      UserPoolId: USER_POOL_ID,
      GroupName: normalizeString(clientName)
    };
    const response = await cognitoIdentityServiceProvider.listUsersInGroup(params).promise();
    return response.Users || [];
  }
});

export {allUsersAdminSelector, useUsersAdminAction };
*/
export { useUsersAdminAction };